// extracted by mini-css-extract-plugin
export default {"divGlobal":"GetNeedUpdate_divGlobal__bbZN+"};